import { withSchema } from '@websolutespa/bom-core';
import { BreadcrumbBase } from './breadcrumb-base';
import { BreadcrumbGroup } from './breadcrumb-group';
import { BreadcrumbItem } from './breadcrumb-item';
import { BreadcrumbSeparator } from './breadcrumb-separator';

export const Breadcrumb = withSchema(
  BreadcrumbBase,
  {
    Item: BreadcrumbItem,
    Separator: BreadcrumbSeparator,
    Group: BreadcrumbGroup,
  });
